export default "__VITE_ASSET__CPiaRG81__"